import { Formatter, ParserFormatter } from './core.js';

export class DateFormatter extends Formatter<Date> {
  protected intlFormatter: Intl.DateTimeFormat;

  constructor(
    locales?: string | string[],
    options?: Intl.DateTimeFormatOptions
  ) {
    super();
    this.intlFormatter = Intl.DateTimeFormat(locales, options);
  }

  format(value: Date): string {
    return this.intlFormatter.format(value);
  }
}

export class ISODateParserFormatter extends ParserFormatter<Date> {
  protected intlFormatter = new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  get type(): string {
    return 'date';
  }

  format(value: Date): string {
    const parts = new Map(
      this.intlFormatter
        .formatToParts(value)
        .map(part => [part.type, part.value])
    );

    return `${parts.get('year')!.padStart(4, '0')}-${parts.get(
      'month'
    )}-${parts.get('day')}`;
  }

  parse(valueStr: string): Date {
    return new Date(Date.parse(valueStr));
  }
}

export function isoDateParserFormatter() {
  return new ISODateParserFormatter();
}

export function dateFormatter(
  locales?: string | string[],
  options?: Intl.DateTimeFormatOptions
): DateFormatter;

export function dateFormatter(
  options: Intl.DateTimeFormatOptions
): DateFormatter;

export function dateFormatter(
  localesOrOptions?: string | string[] | Intl.DateTimeFormatOptions,
  options?: Intl.DateTimeFormatOptions
): DateFormatter {
  if (
    !localesOrOptions ||
    typeof localesOrOptions === 'string' ||
    Array.isArray(localesOrOptions)
  ) {
    return new DateFormatter(localesOrOptions, options);
  }
  return new DateFormatter(undefined, localesOrOptions);
}
